import { useState } from 'react';
import type { ReactNode } from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SupportChatPanel } from './SupportChatPanel';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';

type SupportBubbleProps = {
  hideForAdmins?: boolean;
};

export function SupportBubble({ hideForAdmins = false }: SupportBubbleProps): ReactNode {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const { t } = useTranslation('common');

  if (hideForAdmins && (user?.role === 'admin' || user?.role === 'root_admin' || user?.role === 'demo_admin')) {
    return null;
  }

  return (
    <>
      {open && <SupportChatPanel onClose={() => setOpen(false)} />}
      <div className={"hidden md:block fixed right-token-md bottom-token-md z-40"}>
        <Button
          onClick={() => setOpen(!open)}
          className={`h-12 w-12 rounded-full shadow-token-card transition-all duration-200 bg-success hover:bg-success/90 ${open ? 'ring-2 ring-success/60' : ''}`}
          size="icon"
          aria-label={open ? t('support.closeChat') : t('support.openChat')}
        >
          <MessageCircle className="h-5 w-5" />
        </Button>
      </div>
    </>
  );
}


